import * as types from '../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";
import {ITEMS_PER_PAGE} from '../../components/common/CustomPagination';
import * as spinnerActions from '../spinnerActions';

export function loadMachinesSuccess(machines) {
    return {type: types.LOAD_MACHINES_SUCCESS, machines};
}

export function createMachineSuccess(machine) {
    return {type: types.CREATE_MACHINE_SUCCESS, machine};
}

export function updateMachineSuccess(machine) {
    return {type: types.UPDATE_MACHINE_SUCCESS, machine};
}

export function cloneMachineSuccess(machine) {
    return {type: types.CLONE_MACHINE_SUCCESS, machine};
}

export function deleteMachineSuccess(id) {
    return {type: types.DELETE_MACHINE_SUCCESS, id};
}

export function getMachineSuccess(machine) {
    return {type: types.GET_MACHINE_SUCCESS, machine};
}

export function resetMachine() {
    return { type: types.RESET_MACHINE };
}

export function loadMachines(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.get('machines?page='+page, null, sortParams)
            .then(machines => {
                dispatch(loadMachinesSuccess(machines));
            }).catch(error => {
                throw error;
            });
    }
}

export function getMachine(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('machines', id).then(machine => {
            dispatch(getMachineSuccess(machine))
        }).catch(error => {
            throw error;
        });
    }
}

export function deleteMachine(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('machines', id).then(machine => {
            dispatch(deleteMachineSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

export function saveMachine(machine) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create('machines', machine, true).then(machine => {
            dispatch(createMachineSuccess(machine));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateMachine(machine, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update('machines', id, machine, true).then(machine => {
            dispatch(updateMachineSuccess(machine));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateMachineVimeo(id, data) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update(`machines/${id}`, 'vimeo', data).then(machine => {
            dispatch(createMachineSuccess(machine));
        }).catch(error => {
            throw error;
        })
    }
}

export function cloneMachine(id) {
    return function (dispatch) {
        return PrivateAPIResource.create(`machines/${id}/clone`).then(machine => {
            dispatch(cloneMachineSuccess(machine))
        }).catch(error => {
            throw  error;
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/machines/machinesActions.js